type FelloraMarkProps = {
  className?: string;
  title?: string;
};

/**
 * Canonical Fellora symbol.
 *
 * Do not redraw this mark in feature code. Brand changes are governed by
 * docs/brand/fellora-brand-system.md and require an explicit brand decision.
 */
export function FelloraMark({ className, title }: FelloraMarkProps) {
  const labelled = Boolean(title);
  return (
    <svg
      aria-hidden={labelled ? undefined : true}
      aria-label={labelled ? title : undefined}
      className={className}
      role={labelled ? 'img' : undefined}
      viewBox="0 0 96 96"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M42 44H29C16.85 44 7 34.15 7 22V9h13c12.15 0 22 9.85 22 22v13Z" fill="#42154F" />
      <path d="M54 44V31C54 18.85 63.85 9 76 9h13v13c0 12.15-9.85 22-22 22H54Z" fill="#9668B4" />
      <path d="M42 52v13c0 12.15-9.85 22-22 22H7V74c0-12.15 9.85-22 22-22h13Z" fill="#9668B4" />
      <path d="M54 52h13c12.15 0 22 9.85 22 22v13H76c-12.15 0-22-9.85-22-22V52Z" fill="#42154F" />
    </svg>
  );
}
